// IngredientsSectionStyles.js
import styled from "styled-components";

const bp = { sm: "560px", md: "900px", lg: "1180px" };

const c = {
  black: "#1e1e1e",
  white: "#ffffff",
  soft: "rgba(255,255,255,0.72)",
  gold: "#c9a227",
  pink: "#fc9ac4",
  line: "rgba(255,255,255,0.14)",
};

export const Section = styled.section`
  background: ${c.black};
  color: ${c.white};
  padding: 96px 0 104px;
`;

export const Container = styled.div`
  width: min(1400px, calc(100% - 60px));
  margin: 0 auto;

  @media (max-width: ${bp.sm}) {
    width: calc(100% - 36px);
  }
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 62px;
`;

export const Kicker = styled.div`
  font-family: "Cormorant Garamond", serif;
  font-size: 16px;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: ${c.gold};
`;

export const Title = styled.h2`
  font-family: "Cormorant Garamond", serif;
  font-size: clamp(34px, 3.6vw, 48px);
  font-weight: 600;
  margin: 14px 0 18px;
`;

export const Divider = styled.div`
  width: 92px;
  height: 2px;
  background: ${c.gold};
  margin: 0 auto;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 46px 34px;

  @media (max-width: ${bp.lg}) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 52px 42px;
  }

  @media (max-width: ${bp.md}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 44px 30px;
  }

  @media (max-width: ${bp.sm}) {
    grid-template-columns: 1fr;
    gap: 36px;
  }
`;

export const Item = styled.div`
  text-align: center;
`;

export const IconWrap = styled.div`
  margin-bottom: 18px;
`;

export const IconCircle = styled.div`
  width: 112px;
  height: 112px;
  border-radius: 999px;

  /* disc elegant, fără border auriu */
  background: rgba(255, 255, 255, 0.03);

  /* ring foarte fin în interior (se vede discret, premium) */
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.06);

  /* fără contur default */
  border: 2px solid transparent;

  margin: 0 auto;
  display: grid;
  place-items: center;

  transition:
    border-color 0.35s ease,
    transform 0.35s ease,
    background 0.35s ease,
    box-shadow 0.35s ease;

  ${Item}:hover & {
    border-color: ${c.pink};
    transform: translateY(-3px);
    background: rgba(252, 154, 196, 0.06);

    /* glow roz foarte fin */
    box-shadow:
      inset 0 0 0 1px rgba(255, 255, 255, 0.06),
      0 0 0 6px rgba(252, 154, 196, 0.06);
  }
`;

export const ItemTitle = styled.h3`
  font-family: "Cormorant Garamond", serif;
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 10px;
  letter-spacing: 0.01em;

  color: ${c.gold};
  transition: color 0.35s ease;

  ${Item}:hover & {
    color: ${c.pink};
  }
`;

export const ItemText = styled.p`
  margin: 0 auto;
  max-width: 210px;
  font-size: 14.5px;
  line-height: 1.75;
  color: ${c.soft};
`;

export const IconImg = styled.img`
  width: 56px;
  height: 56px;
  object-fit: contain;

  transition:
    transform 0.35s ease,
    opacity 0.35s ease;

  ${Item}:hover & {
    transform: scale(1.06);
    opacity: 0.95;
  }
`;
